import { render, staticRenderFns } from "./ProjectWasteSampleFormGroup.vue?vue&type=template&id=106637ee"
import script from "./ProjectWasteSampleFormGroup.vue?vue&type=script&lang=js"
export * from "./ProjectWasteSampleFormGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports